// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__hMf9e","content":"Consent_content__2dMui","footer":"Consent_footer__16lIm"};